"use strict";

/**
 * Add format as function to strings - used for templating
 * @param {string[]} args
 * @returns {string}
 * @example
 *
 * const myString = 'Foo {0} bar';
 * const formattedString = myString.format('bar');
 * 
 * console.log(formattedString);
 * 
 * Outputs: Foo bar bar
 * 
 */
(function () {
  String.prototype.format = function () {
    var args = arguments;
    return this.replace(/{(\d+)}/g, function (match, number) {
      return typeof args[number] != 'undefined' ? args[number] : match;
    });
  };
})();